"use strict";
exports.__esModule = true;
var metalog_1 = require("../metalog/app/js/logic/metalog");
function appendPolandData(dataRows) {
    var _loop_1 = function (rowData) {
        var newPoland = new metalog_1.Poland(rowData.polandConstants);
        var points = new metalog_1.PointProducer().thousandPointsFrom(newPoland);
        rowData.polandCDF = points.map(function (point) { return ([point['cdfPoint']['x'], point['cdfPoint']['y']]); });
        rowData.polandPDF = points.map(function (point) { return ([point['pdfPoint']['x'], point['pdfPoint']['y']]); });
        rowData.polandCDF3Points = newPoland.tenFiftyNinety();
        Object.values(rowData.rollUp3Points).forEach(function (pointValue) {
            pointValue.polandCDF = newPoland.cdf(pointValue.value);
        });
        rowData.polandPDF3Points = {
            ten: newPoland.pdf(0.1),
            fifty: newPoland.pdf(0.5),
            ninety: newPoland.pdf(0.9)
        };
    };
    for (var _i = 0, dataRows_1 = dataRows; _i < dataRows_1.length; _i++) {
        var rowData = dataRows_1[_i];
        _loop_1(rowData);
    }
}
function generateTableRow(rows, tableKey) {
    return rows.map(function (row) {
        var res = row[tableKey];
        res.name = row.name;
        res.colorTag = row.name;
        res.color = row.color;
        return res;
    });
}
function generateTableData(graphData, settings) {
    var fitType = settings.currentFit;
    var tableKey = (fitType === 'Monte Carlo' ? 'mc' : 'poland').concat('CDF3Points');
    var mainRows = graphData.main ? generateTableRow(graphData.main, tableKey) : [];
    var siblingRows = graphData.shadow ? generateTableRow(graphData.shadow, tableKey) : [];
    var headerMap = [
        { 'key': 'ten', 'text': 'Low (10 Percentile)' },
        { 'key': 'fifty', 'text': 'Mid (50 Percentile)' },
        { 'key': 'ninety', 'text': 'High (90 Percentile)' }
    ];
    return { mainRows: mainRows, siblingRows: siblingRows, headerMap: headerMap };
}
function appendPolandDataToGraph(graph, settings) {
    var graphData = angular.copy(graph);
    var mainRows = appendPolandData(graphData.main);
    var siblingRows = appendPolandData(graphData.shadow || []);
    var tableData = generateTableData(graphData, settings);
    return {
        graph: graphData,
        table: tableData
    };
}
exports.appendPolandDataToGraph = appendPolandDataToGraph;
//# sourceMappingURL=portfolio-uncertainty2.poland.logic.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/portfolio-uncertainty2/portfolio-uncertainty2.poland.logic.js